async function getRegistryList(params, navParams) {
    try {

        if (!params || params === 'undefined') {
            params = {};
        }

        if (!navParams || navParams === 'undefined') {
            navParams = null;
        }
        let response = await BX.ajax.runComponentAction(
            componentRegistryList.componentName,
            'getRegister', {
                mode: 'class',
                signedParameters: componentRegistryList.signedParameters,
                data: {
                    templateName: componentRegistryList.templateName,
                    params: params,
                    navParams: navParams,
                },
            }).then(function(response) {
            return response;
        });

        return new Promise((resolve, reject) => {
            resolve(response);
        });
    } catch (err) {
        return err.message;
    }
}